/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Not found
 * @export
 * @interface GetCharactersCharacterIdCalendarEventIdAttendeesNotFound
 */
export interface GetCharactersCharacterIdCalendarEventIdAttendeesNotFound {
    /**
     * Not found message
     * @type {string}
     * @memberof GetCharactersCharacterIdCalendarEventIdAttendeesNotFound
     */
    error?: string;
}

/**
 * Check if a given object implements the GetCharactersCharacterIdCalendarEventIdAttendeesNotFound interface.
 */
export function instanceOfGetCharactersCharacterIdCalendarEventIdAttendeesNotFound(value: object): value is GetCharactersCharacterIdCalendarEventIdAttendeesNotFound {
    return true;
}

export function GetCharactersCharacterIdCalendarEventIdAttendeesNotFoundFromJSON(json: any): GetCharactersCharacterIdCalendarEventIdAttendeesNotFound {
    return GetCharactersCharacterIdCalendarEventIdAttendeesNotFoundFromJSONTyped(json, false);
}

export function GetCharactersCharacterIdCalendarEventIdAttendeesNotFoundFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCharactersCharacterIdCalendarEventIdAttendeesNotFound {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function GetCharactersCharacterIdCalendarEventIdAttendeesNotFoundToJSON(json: any): GetCharactersCharacterIdCalendarEventIdAttendeesNotFound {
    return GetCharactersCharacterIdCalendarEventIdAttendeesNotFoundToJSONTyped(json, false);
}

export function GetCharactersCharacterIdCalendarEventIdAttendeesNotFoundToJSONTyped(value?: GetCharactersCharacterIdCalendarEventIdAttendeesNotFound | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'error': value['error'],
    };
}

